import axiosInstance from "@/config/axios/api-client.config";
import { handleApiRequest } from "@/lib/utils";
import { Model } from "@/types/a2i-media.types";

export type ModelCatalogueOptions = {
  catalogueUserId?: string;
  useVertexai?: boolean;
  useNewCatalogue?: boolean;
};

export const getModels = async (
  options: ModelCatalogueOptions = {},
): Promise<Model[]> => {
  try {
    return await handleApiRequest<Model[]>(
      axiosInstance.get(`/models`, {
        params: {
          catalogue_user_id: options.catalogueUserId,
          use_vertexai: options.useVertexai,
          use_new_catalogue: options.useNewCatalogue,
        },
      }),
    );
  } catch (error) {
    console.error("Error fetching models:", error);
    throw error;
  }
};

export const estimatePricing = async (model_data: Record<string, string>) => {
  try {
    const credits = await handleApiRequest<number | null>(
      axiosInstance.post(`/credits/estimate/image-generation`, {
        ...model_data,
      })
    );
    return credits;
  } catch (error) {
    console.error("Error estimating pricing:", error);
    throw error;
  }
};
